export const cleanupObject = (
  object,
  attributes = ['user', 'urls', 'attributes', 'versions', 'likes', 'featured_file', 'capabilities'],
  preserveKeys = {},
) => {
  const cleanObject = window._.cloneDeep(object);

  const urlKeys = [
    'thumbnail',
    'thumbnailx2',
    'thumbnailmasonry',
  ];

  attributes.forEach((attribute) => {
    if (cleanObject[attribute]) {
      if (attribute === 'urls') {
        Object.keys(object.urls).forEach((key) => {
          if (!urlKeys.includes(key)) {
            delete cleanObject.urls[key];
          }
        });
      } else if (preserveKeys[attribute] && Array.isArray(preserveKeys[attribute])) {
        const preserved = {};
        preserveKeys[attribute].forEach((key) => {
          if (object[attribute][key] !== undefined) {
            preserved[key] = object[attribute][key];
          }
        });
        cleanObject[attribute] = preserved;
      } else {
        delete cleanObject[attribute];
      }
    }
  });

  if (cleanObject.collections) {
    cleanObject.collections = window._.uniqBy(object.collections, 'uuid');
  }

  return cleanObject;
};

export const cleanupPageObject = (page) => {
  const cleanPageObject = window._.cloneDeep(page);

  if (cleanPageObject.sections) {
    cleanPageObject.sections.forEach((section, sidx) => {
      if (section.collections) {
        cleanPageObject.sections[sidx].collections = section.collections.map(collection => (
          cleanupObject(collection)
        ));
      }
    });
  }

  return cleanPageObject;
};
